import React from "react";
import { motion } from "framer-motion";
import { BadgeIndianRupee, UserCheck, Headphones, Plane, Sparkles, MapPinned } from "lucide-react";

const FEATURES = [
  { icon: BadgeIndianRupee, title: "Transparent Pricing", desc: "Upfront, honest quotes. What you see is what you pay — no surge, no hidden fees." },
  { icon: UserCheck, title: "Professional Drivers", desc: "Verified, courteous and trained chauffeurs with years of safe driving experience." },
  { icon: Headphones, title: "24/7 Support", desc: "Round-the-clock support on call, WhatsApp and chat — anytime, any day." },
  { icon: Plane, title: "Airport Transfers", desc: "Punctual pickups and drops at every major Indian airport with flight tracking." },
  { icon: Sparkles, title: "Clean Vehicles", desc: "Sanitized cabs with AC, water and comfort essentials for every ride." },
  { icon: MapPinned, title: "Pan India Service", desc: "Outstation, intercity and local trips across 17+ Indian cities and growing." },
];

const WhyChooseUs = () => {
  return (
    <section id="why" data-testid="why-choose-us-section" className="relative py-20 lg:py-28 bg-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-2xl">
          <div className="text-[11px] uppercase tracking-[0.22em] font-bold text-[#19A8E8]">Why Choose Cabsab</div>
          <h2 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-[#0F172A] tracking-tight leading-tight">
            Built for travellers who expect <span className="text-[#19A8E8]">more</span>.
          </h2>
          <p className="mt-4 text-[#64748B] leading-relaxed">
            From quick airport runs to long outstation holidays — we deliver a clean, safe and on-time ride, every single time.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            return (
              <motion.div
                key={f.title}
                data-testid={`feature-card-${f.title.replace(/\s+/g, "-").toLowerCase()}`}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.4, delay: i * 0.05 }}
                className="group relative bg-white border border-slate-200 rounded-2xl p-6 lg:p-7 transition-all hover:-translate-y-1 hover:shadow-[0_12px_30px_rgba(15,23,42,0.08)] hover:border-[#19A8E8]/40"
              >
                <div className="h-12 w-12 rounded-xl bg-[#19A8E8]/10 flex items-center justify-center group-hover:bg-[#19A8E8] transition-colors">
                  <Icon className="h-5 w-5 text-[#19A8E8] group-hover:text-white transition-colors" />
                </div>
                <h3 className="mt-5 font-display font-semibold text-lg text-[#0F172A]">{f.title}</h3>
                <p className="mt-2 text-sm text-[#64748B] leading-relaxed">{f.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
